/**
 * MapResults
 *
 * View that handles interactions on the map view.
 *
 * @return {view}
 */

(function() {
  OT.createNS('OT.Redesign.Views.Results.MapResults');

  OT.Redesign.Views.Results.MapResults = Backbone.ViewManager.BaseView.extend({
    el: '#search_results_map',

    template: 'Redesign/Search/Map/_ResultsMap',

    events: {},

    initialize: function() {
      OT.Events.on('results:updated', this.onResultsUpdated.bind(this));

      if (OT.Search.Helpers.isMapShowing()) {
        //if not called here, then it will be called by onResultsUpdated when map view is activated.
        this.trackHasViewedMap();
        setTimeout(this.setMapListingHeight.bind(this));
      }
      this.registerEasing();
      this.onInitialize();
    },

    onInitialize: function() {
      this.initialized = true;

      this.ResultsListView = new OT.Redesign.Views.Results.Map.ResultsList();
      this.ResultsTitleView = this.ResultsTitleView || new OT.Redesign.Views.Results.Map.ResultsTitle();

      var mapDependencies = {
        getResults: this.getListResults.bind(this),
        scrollTo: this.scrollResultsListTo.bind(this)
      };

      if (OT.Search.Helpers.isMapShowing()) {
        this.MapView = this.MapView || new OT.Redesign.Views.Results.Map.OcReactMap(mapDependencies);
        this.MapView.resetEl();
      }
    },

    getListResults: function () {
      return this.$el.find('.infinite-results-list > .result');
    },

    scrollResultsListTo: function (index) {
      var $results = this.getListResults();
      var listItem = $results.filter('.result[data-id="' + index + '"]').first();

      this.$el.find('.map-results-scroll-container').scrollTo(listItem, 800, {
        easing: 'easeInOutQuint'
      });
    },

    beforeRender: function() {
      this.templateData = OT.Search.Data.get();
      this.additionalData = {
        clearLastFilter: true
      };

      return this;
    },

    onRender: function() {
      this.onInitialize();

      setTimeout(this.afterRender.bind(this));

      OT.Search.recentlyBooked();
    },

    afterRender: function() {
      this.$el.show();
      this.setMapListingHeight();
      new OT.Redesign.Views.SearchTabs();
      (new OT.Redesign.Views.Filters.Sort()).reInitializeSortDropdown();
      OT.Search.stylesheet();

      if (OT.SV1371) {
        OT.SV1371.slideTimeslots('left');
        OT.SV1371.slideTimeslots('right');
      }
    },

    onResultsUpdated: function() {
      if (!OT.Search.Helpers.isMapShowing()) {
        this.unsetView();
        return false;
      }

      if (this.ResultsTitleView) {
        this.ResultsTitleView.unsetView();
      }

      if (this.ResultsListView) {
        this.ResultsListView.unsetView();
      }

      this.render();

      this.ResultsListView.updateResultsList();
      this.ResultsTitleView.render();
      this.MapView.updateResults();
      this.trackHasViewedMap();
    },

    /**
     * Needs to be fired at least once per session wherein a user visits the map view
     */
    trackHasViewedMap: function() {
      optimizely.push(['setDimensionValue', 7223204773, 'HasViewedMap']);
    },

    setMapListingHeight: function() {
      var $resultsScrollContainer = $('.map-results-scroll-container');
      var $resultsContainer = $('#search');
      var $mainArea = $('#search_results_map');
      var $filters = $('#filters-bar');

      var windowHeight = $(window).height();
      var scrollResultsHeight = windowHeight - $resultsScrollContainer[0].getBoundingClientRect().top;
      var filtersBarHeight = windowHeight - $mainArea[0].getBoundingClientRect().top;
      var mapHeight = windowHeight - $mainArea[0].getBoundingClientRect().top;

      if (this.isMobilePortrait()) {
        $filters.css('max-height', filtersBarHeight);
      } else if (OT.Common.Viewport.isTablet()) {
        $resultsScrollContainer.height(scrollResultsHeight);
        $filters.css('max-height', filtersBarHeight);
        $resultsContainer.height(mapHeight);
      } else {
        $resultsScrollContainer.height("");
        $resultsContainer.height("");
        $mainArea.height("");
      }
    },

    isMobilePortrait: function() {
      return OT.Common.Viewport.isPhone() && this.isPortrait();
    },

    isPortrait: function() {
      return screen.height > screen.width;
    },

    registerEasing: function() {
      // http://stackoverflow.com/a/5207328/538646
      $.extend($.easing, {
        easeInOutQuint: function (x, t, b, c, d) {
          if ((t/=d/2) < 1) return c/2*t*t*t*t*t + b;
          return c/2*((t-=2)*t*t*t*t + 2) + b;
        }
      });
    }
  });
})();
